import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { service, factories, models } from 'powerbi-client';

import { PowerBIService } from '../../../../service/proxy';
import { ToastService } from '../../../shared/toast/toast.service';
import { ErrorService } from '../../../shared/services/error-service';

@Component({
    selector: 'app-power-bi-dashboard',
    templateUrl: './power-bi-dashboard.component.html',
    styleUrls: ['./power-bi-dashboard.component.scss'],
    standalone: true,

    imports: [
        CommonModule,
        FormsModule
    ],

    providers: [
        PowerBIService,
        ToastService,
        ErrorService
    ]
})
export class PowerBiDashboardComponent implements OnInit, AfterViewInit {
    public loading = true;
    public embedConfig: any;
    private viewReady = false;
    private configReady = false;
    private powerbiClientService?: service.Service;

    @ViewChild('dashboardContainer', { static: true })
    dashboardContainer!: ElementRef;

    constructor(
        private powerBIService: PowerBIService,
        private toastService: ToastService,
        private errorService: ErrorService
    ) {}

    ngOnInit(): void {
        this.powerBIService.getDashboardEmbedConfig().subscribe({
            next: (config: any) => {
                this.embedConfig = {
                    type: 'dashboard',
                    accessToken: config.accessToken,
                    embedUrl: config.embedUrl,
                    id: config.id,
                    tokenType: models.TokenType.Embed,
                    permissions: models.Permissions.All,

                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: false
                    }
                };

                this.configReady = true;
                this.tryEmbed();
            },
            error: (err) => {
                this.loading = false;
                this.toastService.show('Failed to load Power BI dashboard.', 'error');
                this.errorService.handleError(err);
            }
        });
    }

    ngAfterViewInit(): void {
        this.viewReady = true;
        this.tryEmbed();
    }

    private tryEmbed(): void {

        if (this.viewReady && this.configReady && this.dashboardContainer?.nativeElement) {
            this.powerbiClientService = new service.Service(
                factories.hpmFactory,
                factories.wpmpFactory,
                factories.routerFactory
            );

            this.powerbiClientService.embed(this.dashboardContainer.nativeElement, this.embedConfig);
            this.loading = false;
            this.toastService.show('Dashboard loaded successfully.', 'success');
        }
    }
}
